import { lazy, Suspense } from "react";
import { RouterProvider } from "react-router/dom";
import { createBrowserRouter, } from "react-router-dom";

import { CrashScreen, FourOhFour, } from "@bracket/catch";

import { Notifications, Account as SettingsAccount, Transactions, } from "@sections/SettingsPage/tabs";
import { Kyc as KycManager, Nav, Account as StrategyAccount, } from "@sections/StrategiesPage/tabs";



const DashboardPage = lazy(() => import("@sections/DashboardPage"));
const BarsPage = lazy(() => import("@sections/BarsPage"));
const BrktETHPage = lazy(() => import("@sections/BrktETHPage"));
const InvestPage = lazy(() => import("@sections/InvestPage"));
const MainLayout = lazy(() => import("@sections/MainLayout"));
const SettingsPage = lazy(() => import("@sections/SettingsPage"));
const StrategiesPage = lazy(() => import("@sections/StrategiesPage"));
const VaultPage = lazy(() => import("@sections/VaultPage"));
const AnalyticsPage = lazy(() => import("@sections/AnalyticsPage"));
const OpenSourceNoticesPage = lazy(() => import("@sections/OpenSourceNoticesPage"));



const router = createBrowserRouter([
	{
		path: "/",
		element: <Suspense fallback={null}><MainLayout /></Suspense>,
		errorElement: <CrashScreen />,
		children: [
			{
				path: "/",
				element: <Suspense fallback={null}><InvestPage /></Suspense>,
			},
			{
				path: "/dashboard",
				element: <Suspense fallback={null}><DashboardPage /></Suspense>,
			},
			{
				path: "/get-brkteth",
				element: <Suspense fallback={null}><BrktETHPage /></Suspense>,
			},
			{
				path: "/invest",
				element: <Suspense fallback={null}><InvestPage /></Suspense>,
			},
			{
				path: "/invest/:symbol",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/terms-and-fees",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/description",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/transactions",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/enforced-capabilities",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/addresses",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/nav-history",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/holdings",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/invest/:symbol/charts",
				element: <Suspense fallback={null}><VaultPage /></Suspense>,
			},
			{
				path: "/bars/leaderboard",
				element: <Suspense fallback={null}><BarsPage /></Suspense>,
			},
			{
				path: "/bars/about",
				element: <Suspense fallback={null}><BarsPage /></Suspense>,
			},
			{
				path: "/bars",
				element: <Suspense fallback={null}><BarsPage /></Suspense>,
			},
			{
				path: "/settings",
				element: <Suspense fallback={null}><SettingsPage /></Suspense>,
				children: [
					{
						path: "/settings",
						element: <Transactions />,
					},
					{
						path: "/settings/account",
						element: <SettingsAccount />,
					},
					{
						path: "/settings/transaction-log",
						element: <Transactions />,
					},
					{
						path: "/settings/notifications",
						element: <Notifications />,
					},
				],
			},
			{
				path: "/strategies",
				element: <Suspense fallback={<div>Loading...</div>}><StrategiesPage /></Suspense>,
				children: [
					{
						path: "/strategies",
						element: <StrategyAccount />,
					},
					{
						path: "/strategies/account",
						element: <StrategyAccount />,
					},
					{
						path: "/strategies/nav",
						element: <Nav />,
					},
					{
						path: "/strategies/notifications",
						element: <Notifications />,
					},
					{
						path: "/strategies/kyc",
						element: <KycManager />,
					}
				],
			},
			{
				path: "/analytics",
				element: <Suspense fallback={<div>Loading...</div>}><AnalyticsPage /></Suspense>,
			},
			{
				path: "/legal/open-source",
				element: <Suspense fallback={null}><OpenSourceNoticesPage /></Suspense>,
			},
			{
				path: "*",
				element: <FourOhFour />
			}
		],
	},
]);


export const AppRouter = () => {
	return <RouterProvider router={router} />;
};
